module.exports = __webpack_public_path__ + "img/ticket-icon.37c3e622.svg";